  import { defineComponent, type PropType } from "vue";
  import RibIban from '@/extend/controls/rib/RibIban';
  import Rib from '@/extend/classes/Rib';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeRib } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      RibIban,
    },

    props: {
      rib: {
        type: Object as PropType<Rib>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
        ibanStatus: new FieldStatus(false, false, 0),
        strIban: '',
        refRib: new Rib,
        cloneRib: new Rib,
      ribSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.RIB,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editRib.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editRib: {
        get(): Rib {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.rib != undefined) {
              if (this.rib.id == 0) {
                Alerts.debug('CrudRib : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneRib.id != this.rib.id && !this.saving) {
                this.handleRibChange();
              }
            }
          }
          return this.refRib;
        },
        set(value: Rib) {
          this.refRib = value;
        }
      },

      canCreate (): boolean {
        return this.refRib.id > 0;
      },

      canDelete (): boolean {
        return this.refRib.canDelete && this.refRib.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },


      iban: {
        get(): string {
          return this.editRib.iban;
        },
        set(value: string) {
          this.editRib.iban = value;
          this.fieldUpdated('IBAN', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.rib.canUpdate && (
        (this.isDisplayed('IBAN') && !this.readOnly('IBAN')));
        return !res;
      },

      fields (): string[] {
        return ['IBAN'];
      },
    },

    methods: {
      handleRibChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.rib);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.rib);
          }
        } else if (!this.inDialog) {
          if (this.cloneRib.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.rib);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.ibanStatus != undefined && this.ibanStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.rib);
        }
      },

      setError (): void {
        const error = this.ibanStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.rib);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refRib.id < 0) {
          storeRib.mRibDeleted(this.refRib.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refRib.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveRib()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.ribSaving = false;
          this.createRef(this.refRib);
          this.$emit('updated', this.refRib);
          if (this.rib.id > 0) {
            this.$emit('saved', this.refRib);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refRib.failed) {
          this.saveLoading = false;
            this.ribSaving = false;
            this.refRib.failed = false;
          }
        }
      },

      saveRib (): boolean {
        if (!this.refRib.compareRib(this.cloneRib)) {
          if (!this.ribSaving) {
            this.ribSaving = true;
          if (this.refRib.id > 0) {
            storeRib.updateRib(this.refRib)
              .then((data: Rib) => {
                if (!data.failed) {
                  this.refRib = storeRib.getRib(data.id);
                  this.cloneRib = data.cloneRib();
                } else {
                  this.refRib.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.ribSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refRib.id <= 0) {
              storeRib.createRib(this.refRib)
                .then((data: Rib) => {
                  if (!data.failed) {
                    this.refRib = storeRib.getRib(data.id);
                    this.cloneRib = data.cloneRib();
                  } else {
                this.refRib.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.ribSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refRib.id <= 0) {
          storeRib.mRibDeleted(this.refRib.id);
        } else {
          storeRib.deleteRib(this.refRib);
        }
      },

      statusIban (value: FieldStatus): void {
        this.ibanStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteRib(): void {
        this.$emit('deleteRib',  this.rib);
      },

    addRib(): void {
      this.$emit('addRib',  this.rib);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneRib != undefined) {
          this.restoring = true;
          this.refRib.iban = this.cloneRib.iban;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: Rib): void {
        this.clearRef();
        this.editRib = value;
        this.cloneRib = value.cloneRib();
        this.ibanStatus.clear(value.id);
        this.status.clear();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('IBAN') && this.$refs.IBAN) this.$refs.IBAN.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'IBAN') && this.isDisplayed('IBAN') && this.$refs.IBAN && this.$refs.IBAN.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('IBAN') && this.$refs.IBAN) this.$refs.IBAN.save();
      },

      getValue (field: string): string {
         if (field == 'IBAN') return this.iban.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
